import axios from "axios";
import { SERVER_URL } from "../../config";
import { appendTimestamp } from "../../common/shared";
import store from "../../redux/store";

export const getDefaultPlanSettings = (userId) => {
  console.log("Default Plan Settings API - getDefaultPlanSettings");

  return new Promise((resolve, reject) => {
    let targetUrl = appendTimestamp(
      `${SERVER_URL}/admin/${userId}/settings/plan/default`
    );

    axios.get(targetUrl).then((response) => {
      resolve(response.data.payload);
    });
  });
};

export const saveDefaultPlanSettings = (userId, firmId) => {
  console.log("Default Plan Settings API - saveDefaultPlanSettings");

  return new Promise((resolve, reject) => {
    let targetUrl = appendTimestamp(
      `${SERVER_URL}/admin/${userId}/settings/plan/default`
    );

    let settings = store.getState().settingsReducer;

    let data = {
      firmId: firmId,
      defaultSettings: {
        inflationAndDiscount: {
          isSystemWideInflation: settings.getIn([
            "admin",
            "defaultInflation",
            "isSystemWide",
          ]),
          systemWideInflation:
            settings.getIn([
              "admin",
              "defaultInflation",
              "systemWideInflation",
            ]) * 100,
          discountRate:
            settings.getIn(["admin", "defaultInflation", "discountRate"]) * 100,
          incomeInflation:
            settings.getIn(["admin", "defaultInflation", "income"]) * 100,
          contributionsWithdrawalInflation:
            settings.getIn(["admin", "defaultInflation", "contributions"]) *
            100,
          goalInflation:
            settings.getIn(["admin", "defaultInflation", "goal"]) * 100,
          expenseInflation:
            settings.getIn(["admin", "defaultInflation", "expense"]) * 100,
        },
        planSimulation: {
          isFutureValue: settings.getIn([
            "admin",
            "planSimulation",
            "futureValue",
          ]),
          isLogarithimic: settings.getIn([
            "admin",
            "planSimulation",
            "logarithmic",
          ]),
          isProrateFirstYear: settings.getIn([
            "admin",
            "planSimulation",
            "proRateFirstYear",
          ]),
          numberOfSimulation: settings.getIn([
            "admin",
            "planSimulation",
            "numberOfSimulations",
          ]),
        },
        clientKeyDates: {
          retirementAge: settings.getIn([
            "admin",
            "clientKeyDates",
            "retirementAge",
          ]),
          lifeExpectancyAge: settings.getIn([
            "admin",
            "clientKeyDates",
            "lifeExpectancy",
          ]),
        },
        trackingThresholds: {
          goalBasedPlan: {
            min:
              settings.getIn([
                "admin",
                "trackingThresholds",
                "goalBased",
                "from",
              ]) * 100,
            max:
              settings.getIn([
                "admin",
                "trackingThresholds",
                "goalBased",
                "to",
              ]) * 100,
          },
          safeSavingsRatePlan: {
            min:
              settings.getIn([
                "admin",
                "trackingThresholds",
                "ssrPlan",
                "from",
              ]) * 100,
            max:
              settings.getIn(["admin", "trackingThresholds", "ssrPlan", "to"]) *
              100,
          },
        },
      },
    };

    axios.post(targetUrl, data).then((response) => {
      resolve(response.data.payload);
    });
  });
};

export const getSurvivorBenefits = (userId) => {
  console.log("getSurvivorBenefits");

  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/admin/${userId}/settings/plan/social-security-survivor-benefit`;

    axios.get(targetUrl).then((response) => {
      resolve(
        response.data.payload.map((item, index) => {
          return {
            ...item,
            inEdit: false,
            editIndex: index,
            yearOfBirth:
              index === 0 ? `${item.yearOfBirth} or earlier` : item.yearOfBirth,
            monthlyReduction: item.monthlyReduction.toFixed(3),
          };
        })
      );
    });
  });
};

export const saveSurvivorBenefits = (userId, payload) => {
  console.log("saveSurvivorBenefits");

  return new Promise((resolve, reject) => {
    const targetUrl = `${SERVER_URL}/admin/${userId}/settings/plan/social-security-survivor-benefit`;

    axios
      .post(
        targetUrl,
        payload.map((item) => {
          return {
            ...item,
            monthlyReduction: item.monthlyReduction * 100,
            edited: true,
          };
        })
      )
      .then((response) => {
        resolve(
          response.data.payload.map((item, index) => {
            return {
              ...item,
              inEdit: false,
              editIndex: index,
              monthlyReduction: item.monthlyReduction / 100,
            };
          })
        );
      });
  });
};

export const getDefaultContributionLimits = (advisorId) => {
  console.log("Default Plan Settings API - getDefaultPlanSettings");

  return new Promise((resolve, reject) => {
    let targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/settings/plan/default-contribution-limits`
    );

    axios.get(targetUrl).then((response) => {
      resolve(response.data.payload);
    });
  });
};
